import React, {FC} from 'react';

/**
 * 隐私政策俄语正文（结构与 en.tsx / zh.tsx 逐元素 1:1，类名复用 PrivacyPolicy__* BEM）
 * 2026-09-17 AI-перевод, юридические формулировки ожидают проверки бизнесом
 */
const RuContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Дата вступления в силу: August 28, 2026</p>
      <p className="v3-doc-meta">Дата последнего обновления: August 28, 2026</p>
      <h3>Заявление о защите конфиденциальности</h3>
      <p>Благодарим вас за использование продуктов и услуг, предоставляемых компанией Xiangji!</p>
      <p>
        Xiangji (далее — «Xiangji» или «мы») придает большое значение защите ваших персональных данных и
        конфиденциальности. Настоящая Политика конфиденциальности (далее — «настоящая Политика») разъясняет, каким
        образом мы собираем, используем, храним, передаем, защищаем и обрабатываем ваши персональные данные, когда вы
        регистрируетесь, входите в систему, посещаете или используете веб-сайт, веб-приложение, клиентское приложение,
        браузерное расширение, API и иные связанные услуги Xiangji, а также права, которыми вы обладаете в соответствии
        с применимым законодательством.
      </p>
      <p>
        Xiangji в основном предоставляет услуги обработки и создания визуального контента с использованием ИИ для
        пользователей трансграничной электронной торговли и иных бизнес-пользователей, включая, помимо прочего, перевод
        изображений, редактирование изображений, генерацию изображений, генерацию сценарных изображений товаров,
        генерацию изображений товаров с моделями, генерацию главных и дополнительных изображений товаров, генерацию
        комплектов детальных изображений товаров, создание маркетинговых материалов и иные связанные услуги.
      </p>
      <p>
        <strong>
          Просим вас внимательно прочитать настоящую Политику и убедиться в ее полном понимании до начала использования
          услуг Xiangji, в особенности положения, выделенные полужирным шрифтом и затрагивающие ваши существенные права
          и интересы.
        </strong>
      </p>
      <p>
        Настоящая Политика вместе с Условиями использования Xiangji, Соглашением о приобретении подписки Xiangji и иными
        применимыми специальными соглашениями об отдельных услугах образует полную систему условий оказания услуг
        Xiangji.
      </p>
      <p>
        Если вы не согласны с каким-либо положением настоящей Политики, просим прекратить использование услуг Xiangji.
      </p>
      <section>
        <h2>1. Какую информацию мы собираем</h2>
        <p>
          В зависимости от конкретных функций Xiangji, которые вы используете, и от характера вашего взаимодействия с
          нами мы можем собирать следующие типы информации.
        </p>
        <h3>Сведения об учетной записи и личности</h3>
        <p>При регистрации, входе в систему или использовании услуг Xiangji мы можем собирать:</p>
        <ul>
          <li>Имя или никнейм;</li>
          <li>Адрес электронной почты;</li>
          <li>Номер мобильного телефона;</li>
          <li>Фотография профиля (аватар);</li>
          <li>Сведения о сторонних учетных записях;</li>
          <li>Идентификатор учетной записи;</li>
          <li>Наименование компании, должность и иные сведения, предоставленные вами добровольно;</li>
          <li>
            Иная информация, используемая для регистрации учетной записи, подтверждения личности и управления учетной
            записью.
          </li>
        </ul>
        <p>
          Если вы входите в систему с использованием учетной записи Google, Apple, WeChat или иной сторонней учетной
          записи, мы можем получать часть вашей общедоступной информации об учетной записи в пределах, авторизованных
          соответствующей сторонней платформой.
        </p>
        <p>
          <strong>Мы не получаем пароль от вашей сторонней учетной записи в связи с входом в систему через нее.</strong>
        </p>
        <h3>Загружаемый и предоставляемый пользователями контент</h3>
        <p>
          Xiangji представляет собой сервис создания и обработки визуального контента с использованием ИИ. В связи с
          этим при активном использовании вами соответствующих функций мы можем обрабатывать загружаемый,
          предоставляемый или вводимый вами контент, включая, помимо прочего:
        </p>
        <ul>
          <li>Изображения товаров;</li>
          <li>Детальные изображения товаров;</li>
          <li>Главные и дополнительные изображения товаров;</li>
          <li>Текст на изображениях;</li>
          <li>Наименования, описания, характеристики и параметры товаров;</li>
          <li>Промпты и иные текстовые инструкции;</li>
          <li>Инструкции по редактированию изображений;</li>
          <li>Видеозаписи и аудиозаписи;</li>
          <li>Файлы PSD и иные дизайн-файлы;</li>
          <li>Результаты, сгенерированные ИИ;</li>
          <li>Иной контент, предоставленный вами добровольно.</li>
        </ul>
        <p>
          <strong>
            Указанный контент может содержать коммерческую тайну, коммерческие материалы или иную информацию,
            представляющую коммерческую ценность. Перед загрузкой просим убедиться, что вы вправе предоставить такой
            контент Xiangji для обработки.
          </strong>
        </p>
        <h3>Сведения о сделках и платежах</h3>
        <p>При приобретении подписки Xiangji или иных платных услуг мы можем собирать:</p>
        <ul>
          <li>Сведения о заказах;</li>
          <li>Приобретаемые вами тарифные планы и услуги;</li>
          <li>Суммы транзакций;</li>
          <li>Время транзакций;</li>
          <li>Статус платежей;</li>
          <li>Счета-фактуры и связанная с ними информация;</li>
          <li>Сведения об учетной записи, связанные с транзакцией.</li>
        </ul>
        <p>
          <strong>
            В отношении конфиденциальной платежной информации, такой как номера банковских карт, номера кредитных карт и
            платежные пароли, ее обработка, как правило, осуществляется непосредственно сторонними платежными
            провайдерами; как принцип, Xiangji не хранит напрямую полные номера банковских карт или платежные пароли.
          </strong>
        </p>
        <p>
          Конкретные способы обработки платежной информации также определяются политикой конфиденциальности
          соответствующего платежного провайдера.
        </p>
        <h3>Сведения об устройствах и журналы</h3>
        <p>При посещении или использовании услуг Xiangji мы можем автоматически собирать:</p>
        <ul>
          <li>IP-адреса;</li>
          <li>Тип и версия браузера;</li>
          <li>Операционная система;</li>
          <li>Тип устройства;</li>
          <li>Идентификаторы устройства;</li>
          <li>Языковые настройки;</li>
          <li>Часовой пояс;</li>
          <li>Время доступа;</li>
          <li>Записи о посещении страниц;</li>
          <li>Записи о кликах, операциях и использовании функций;</li>
          <li>Записи вызовов API;</li>
          <li>Журналы ошибок;</li>
          <li>Состояние сети;</li>
          <li>Иные необходимые технические журнальные сведения.</li>
        </ul>
        <p>
          Данная информация используется главным образом для обеспечения надлежащей работы услуг, анализа сбоев,
          улучшения опыта использования продукта и обеспечения безопасности платформы.
        </p>
        <h3>Файлы cookie и аналогичные технологии</h3>
        <p>Мы можем использовать файлы cookie, Local Storage, SDK и иные аналогичные технологии в целях:</p>
        <ul>
          <li>Поддержания вашего сеанса входа в систему;</li>
          <li>Сохранения ваших предпочтений;</li>
          <li>Запоминания ваших предыдущих действий;</li>
          <li>Анализа использования продукта;</li>
          <li>Обеспечения безопасности учетной записи и услуг;</li>
          <li>Улучшения функциональности продукта;</li>
          <li>Оценки объема использования услуг.</li>
        </ul>
        <p>
          <strong>
            Вы можете управлять файлами cookie или удалять их через настройки браузера или устройства, однако отключение
            отдельных файлов cookie может привести к некорректной работе отдельных функций.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. Как мы используем ваши персональные данные</h2>
        <p>
          Мы обрабатываем ваши персональные данные в законных, добросовестных и необходимых целях, главным образом в
          следующих сценариях:
        </p>
        <h3>Предоставление и поддержание услуг</h3>
        <p>Это включает:</p>
        <ul>
          <li>Создание и управление вашей учетной записью;</li>
          <li>Подтверждение вашей личности;</li>
          <li>Предоставление услуг перевода изображений;</li>
          <li>Предоставление услуг редактирования и обработки изображений;</li>
          <li>Предоставление услуг генерации изображений с помощью ИИ;</li>
          <li>
            Предоставление услуг генерации комплектов детальных изображений товаров, а также главных и дополнительных
            изображений;
          </li>
          <li>Предоставление услуг обработки видео и иного визуального контента;</li>
          <li>Сохранение ваших работ и истории;</li>
          <li>Обработка ваших заказов и подписок;</li>
          <li>Предоставление клиентской поддержки.</li>
        </ul>
        <h3>Обработка в рамках ИИ-сервисов</h3>
        <p>
          При использовании функций, связанных с ИИ, мы можем использовать предоставленные вами изображения, текст,
          промпты, информацию о товарах и иные вводные данные для того, чтобы:
        </p>
        <ul>
          <li>Понимать ваши потребности;</li>
          <li>Вызывать соответствующие ИИ-модели;</li>
          <li>Выполнять перевод, генерацию, редактирование или обработку изображений;</li>
          <li>Формировать выходные данные ИИ;</li>
          <li>Сохранять историю генераций;</li>
          <li>Отображать вам сгенерированные результаты;</li>
          <li>Оптимизировать опыт использования соответствующих услуг.</li>
        </ul>
        <p>
          <strong>
            Для оказания услуг, связанных с ИИ, нам может потребоваться передавать данные, необходимые для реализации
            конкретных функций, соответствующим провайдерам ИИ-моделей, облачным провайдерам или иным поставщикам
            технических услуг. Подробности см. в разделе настоящей Политики «Передача информации, доверенная обработка и
            сторонние сервисы».
          </strong>
        </p>
        <h3>Улучшение сервиса и продуктовая аналитика</h3>
        <p>
          С соблюдением применимых законов и нормативных актов и условий настоящей Политики мы можем использовать
          соответствующую информацию для:
        </p>
        <ul>
          <li>Продуктовой аналитики;</li>
          <li>Анализа качества услуг;</li>
          <li>Выявления и устранения неисправностей;</li>
          <li>Оптимизации производительности;</li>
          <li>Улучшения пользовательского опыта;</li>
          <li>Разработки функциональных возможностей продукта;</li>
          <li>Анализа рисков безопасности.</li>
        </ul>
        <p>
          <strong>
            Если мы не получим ваше отдельное разрешение либо если это не разрешено применимыми законами и нормативными
            актами, мы не будем использовать ваши персональные данные в целях, не связанных с первоначальными целями
            сбора.
          </strong>
        </p>
        <h3>Клиентское обслуживание</h3>
        <p>
          Когда вы обращаетесь к нам с вопросами, жалобами или отзывами, мы можем использовать предоставленную вами
          информацию для подтверждения вашей личности, выяснения сути вопроса и оказания вам услуг.
        </p>
        <h3>Безопасность и контроль рисков</h3>
        <p>Мы можем использовать соответствующую информацию для того, чтобы:</p>
        <ul>
          <li>Предотвращать кражу учетных записей;</li>
          <li>Предотвращать мошенничество;</li>
          <li>Выявлять аномальные входы в систему;</li>
          <li>Предотвращать вредоносные вызовы;</li>
          <li>Предотвращать накрутку трафика и арбитраж;</li>
          <li>Выявлять нарушения правил платформы;</li>
          <li>Обеспечивать безопасность платформы и ее пользователей.</li>
        </ul>
        <h3>Уведомления и маркетинг</h3>
        <p>Мы можем направлять вам важные уведомления, связанные с услугами, например:</p>
        <ul>
          <li>Уведомления о безопасности учетной записи;</li>
          <li>Уведомления о заказах и платежах;</li>
          <li>Уведомления о статусе подписки;</li>
          <li>Уведомления об изменениях услуг;</li>
          <li>Уведомления об обновлениях настоящей Политики конфиденциальности и условий оказания услуг.</li>
        </ul>
        <p>
          <strong>
            Вышеперечисленное представляет собой важные уведомления, необходимые для оказания услуг, и, как правило, вы
            не можете отказаться от их получения.
          </strong>
        </p>
        <p>
          Маркетинговые сообщения, рекламные акции и иная коммерческая информация будут направляться вам в соответствии
          с применимыми законами и нормативными актами и соответствующими правилами авторизации. В случаях, когда это
          требуется законом, мы предоставим соответствующие возможности отказа или отписки.
        </p>
      </section>
      <section>
        <h2>3. Особые положения об ИИ-сервисах и загружаемом пользователями контенте</h2>
        <p>
          Поскольку Xiangji предоставляет услуги создания визуального контента с использованием ИИ, в настоящем разделе
          приводятся особые разъяснения относительно соответствующей обработки данных.
        </p>
        <h3>Загружаемый пользователями контент</h3>
        <p>
          Когда вы активно загружаете изображения, текст, видео, файлы PSD или иной контент и просите Xiangji выполнить
          их обработку, мы обрабатываем такой контент в объеме, необходимом для оказания соответствующих услуг.
        </p>
        <p>Например:</p>
        <p>
          Вы загружаете изображение товара и выбираете «Перевод изображений». Мы можем обработать визуальный контент и
          текст на изображении, чтобы выполнить перевод и сгенерировать новое изображение.
        </p>
        <p>
          Вы вводите информацию о товаре и выбираете «Генерация главного изображения». Мы можем обработать
          соответствующую информацию о товаре и ваши инструкции по генерации, чтобы выполнить задачу генерации ИИ.
        </p>
        <h3>Сервисы ИИ-моделей</h3>
        <p>
          <strong>
            Для реализации отдельных ИИ-функций ваши вводные данные может потребоваться передать сторонним ИИ-моделям
            или поставщикам технических услуг, используемым Xiangji.
          </strong>
        </p>
        <p>
          Исходя из бизнес-потребностей, мы выбираем поставщиков, обладающих соответствующими возможностями обеспечения
          безопасности и условиями оказания услуг, и управляем соответствующими данными в соответствии с применимыми
          законами и нормативными актами, а также договорными соглашениями.
        </p>
        <p>
          Конкретные сторонние сервисы могут изменяться по мере корректировки технических решений и функциональности
          продукта.
        </p>
        <h3>Принцип неиспользования для обучения</h3>
        <p>
          <strong>
            Если мы не получим вашего явного разрешения, если это не разрешено применимыми законами и нормативными
            актами или если на соответствующих страницах услуг прямо не предусмотрено иное, Xiangji не использует
            загруженные вами коммерческие материалы, изображения товаров, промпты или иной пользовательский контент для
            обучения сторонних ИИ-моделей.
          </strong>
        </p>
        <p>
          Если в будущем мы планируем использовать такие данные для обучения моделей, оптимизации алгоритмов или в иных
          целях, существенно отличающихся от первоначальных целей оказания услуг, мы выполним соответствующие
          обязанности по уведомлению и получению разрешения в соответствии с применимыми законами и нормативными актами.
        </p>
        <h3>Результаты, сгенерированные ИИ</h3>
        <p>
          Результаты, сгенерированные ИИ, могут содержать информацию или контент, отличающиеся от исходных вводных
          данных.
        </p>
        <p>
          Мы можем сохранять ваши задачи генерации и их результаты, чтобы предоставлять вам такие функции продукта, как
          история, скачивание и повторное редактирование.
        </p>
        <p>
          <strong>
            Вы должны самостоятельно проверять результаты, сгенерированные ИИ, с учетом ваших фактических сценариев
            коммерческого использования.
          </strong>
        </p>
      </section>
      <section>
        <h2>4. Как мы передаем вашу информацию и поручаем ее обработку</h2>
        <p>Мы не продаем ваши персональные данные.</p>
        <p>
          В следующих обстоятельствах мы можем передавать необходимую информацию третьим сторонам или поручать им ее
          обработку:
        </p>
        <h3>Поставщики технических услуг</h3>
        <p>Для оказания услуг Xiangji мы можем использовать следующие услуги, предоставляемые третьими сторонами:</p>
        <ul>
          <li>Услуги облачных вычислений;</li>
          <li>Услуги объектного хранения данных;</li>
          <li>Сервисы ИИ-моделей;</li>
          <li>Услуги машинного перевода;</li>
          <li>Услуги OCR;</li>
          <li>Услуги обработки изображений;</li>
          <li>Услуги анализа данных;</li>
          <li>Услуги клиентской поддержки;</li>
          <li>Услуги электронной почты и SMS;</li>
          <li>Платежные услуги;</li>
          <li>Услуги безопасности.</li>
        </ul>
        <p>
          <strong>
            Мы предоставляем соответствующим поставщикам только информацию, необходимую для выполнения конкретных услуг,
            и требуем от них обработки соответствующей информации в соответствии с применимыми законами и нормативными
            актами и договоренностями между сторонами.
          </strong>
        </p>
        <h3>Платежные провайдеры</h3>
        <p>
          При приобретении платных услуг соответствующие транзакции могут выполняться сторонними платежными
          организациями.
        </p>
        <p>
          Платежные организации могут самостоятельно обрабатывать связанную с платежами информацию в соответствии со
          своими политиками конфиденциальности.
        </p>
        <h3>Корпоративные клиенты</h3>
        <p>
          Если вы используете услуги Xiangji через учетную запись, предоставленную компанией, учебным заведением или
          иной организацией, часть информации о вашей учетной записи и об использовании услуг может управляться
          соответствующей организацией.
        </p>
        <p>
          Если соответствующая организация выступает обработчиком ваших персональных данных или администратором вашего
          бизнеса, вам следует также ознакомиться с ее правилами обработки данных у данной организации.
        </p>
        <h3>Законодательные и нормативные требования</h3>
        <p>
          В следующих обстоятельствах мы можем раскрывать соответствующую информацию в соответствии с законами и
          нормативными актами либо законными требованиями государственных, судебных или надзорных органов:
        </p>
        <ul>
          <li>Исполнение установленных законом обязанностей;</li>
          <li>Содействие судебным расследованиям;</li>
          <li>Содействие административным расследованиям;</li>
          <li>Защита безопасности пользователей или общественности;</li>
          <li>Защита законных прав и интересов Xiangji;</li>
          <li>Урегулирование мошеннических, противоправных или связанных с безопасностью инцидентов.</li>
        </ul>
        <h3>Изменения в корпоративной деятельности</h3>
        <p>
          В случае слияния, разделения, поглощения, передачи активов, реструктуризации Xiangji или иной подобной сделки
          ваши персональные данные могут быть переданы в составе соответствующих бизнес-активов.
        </p>
        <p>
          <strong>
            Если такая сделка приводит к существенным изменениям целей или способов обработки персональных данных, мы
            выполним соответствующие обязанности по уведомлению в соответствии с применимыми законами и нормативными
            актами.
          </strong>
        </p>
      </section>
      <section>
        <h2>5. Трансграничная передача персональных данных</h2>
        <p>
          Xiangji обслуживает пользователей трансграничной электронной торговли по всему миру. Часть серверов,
          ИИ-моделей, облачных сервисов или иных поставщиков технических услуг может находиться за пределами Китая.
        </p>
        <p>
          Поэтому,
          <strong>
            в отдельных случаях для оказания вам услуг нам может потребоваться передавать ваши соответствующие
            персональные данные или пользовательский контент в другие страны или регионы для обработки.
          </strong>
        </p>
        <p>Например:</p>
        <ul>
          <li>Вы используете зарубежную ИИ-модель для выполнения генерации изображений;</li>
          <li>Вы используете зарубежный облачный сервис для хранения или обработки данных;</li>
          <li>Вы используете зарубежный платежный сервис для оформления подписки;</li>
          <li>Вы используете зарубежные сервисы клиентской поддержки, электронной почты или анализа данных.</li>
        </ul>
        <p>
          <strong>
            Если соответствующая обработка данных предполагает трансграничную передачу персональных данных, мы выполним
            соответствующие обязательства по обеспечению соответствия согласно применимым законам и нормативным актам и
            примем разумные меры защиты безопасности.
          </strong>
        </p>
        <p>
          Для пользователей из разных регионов мы можем применять различные механизмы трансграничной обработки данных в
          соответствии с применимыми законами и нормативными актами.
        </p>
      </section>
      <section>
        <h2>6. Как мы защищаем ваши персональные данные</h2>
        <p>
          Мы придаем серьезное значение безопасности персональных данных и принимаем разумные технические и
          административные меры для защиты вашей информации, включая, помимо прочего:
        </p>
        <ul>
          <li>Шифрование передачи данных;</li>
          <li>Контроль прав доступа к данным;</li>
          <li>Аутентификация личности и управление правами доступа;</li>
          <li>Ведение журналов и мониторинг безопасности;</li>
          <li>Резервное копирование данных;</li>
          <li>Выявление аномального доступа;</li>
          <li>Механизмы реагирования на инциденты безопасности.</li>
        </ul>
        <p>
          <strong>
            С учетом фактических обстоятельств нашей деятельности мы принимаем разумные меры для предотвращения
            несанкционированного доступа к персональным данным, их использования, изменения, раскрытия, утраты или
            уничтожения.
          </strong>
        </p>
        <p>Однако среда Интернета не является абсолютно безопасной.</p>
        <p>
          В случае инцидента, связанного с безопасностью персональных данных, мы примем соответствующие меры в
          соответствии с применимыми законами и нормативными актами и, если этого требует закон, незамедлительно
          уведомим затронутых пользователей и надзорные органы.
        </p>
      </section>
      <section>
        <h2>7. Хранение персональных данных</h2>
        <p>
          Мы храним ваши персональные данные только в течение срока, необходимого для достижения целей, описанных в
          настоящей Политике.
        </p>
        <p>Срок хранения определяется главным образом следующими факторами:</p>
        <ul>
          <li>Срок, необходимый для оказания соответствующих услуг;</li>
          <li>Срок, необходимый для поддержания вашей учетной записи и истории;</li>
          <li>Сроки хранения, установленные законами и нормативными актами;</li>
          <li>Срок, необходимый для разрешения споров и рассмотрения жалоб;</li>
          <li>Срок, необходимый для исполнения иных установленных законом обязанностей.</li>
        </ul>
        <p>
          <strong>
            По истечении срока хранения мы удалим или обезличим соответствующую информацию либо обработаем ее иными
            законными способами в соответствии с применимыми законами и нормативными актами.
          </strong>
        </p>
        <p>
          В отношении изображений, видео, файлов PSD, промптов и иного загружаемого вами контента мы определяем срок
          хранения исходя из конкретных функций продукта, состояния вашей учетной записи и правил хранения.
        </p>
      </section>
      <section>
        <h2>8. Ваши права в отношении персональных данных</h2>
        <p>
          В пределах, установленных применимыми законами и нормативными актами, вы можете пользоваться следующими
          правами:
        </p>
        <h3>Доступ и получение сведений</h3>
        <p>Вы можете запрашивать сведения о хранящихся у нас персональных данных о вас или получать к ним доступ.</p>
        <h3>Исправление</h3>
        <p>
          Если вы обнаружите, что ваши персональные данные содержат ошибки или неточности, вы можете потребовать от нас
          их исправления.
        </p>
        <h3>Удаление</h3>
        <p>
          В случаях, предусмотренных законами и нормативными актами, вы можете потребовать от нас удаления
          соответствующих персональных данных.
        </p>
        <h3>Аннулирование учетной записи</h3>
        <p>Вы можете подать заявление на аннулирование учетной записи способами, предусмотренными Xiangji.</p>
        <p>
          <strong>
            После аннулирования вашей учетной записи часть сервисных данных и неиспользованные преимущества услуг могут
            утратить силу или быть удалены в соответствии с соответствующими правилами, за исключением информации,
            хранение которой требуется законами и нормативными актами.
          </strong>
        </p>
        <h3>Отзыв разрешения</h3>
        <p>В пределах, допускаемых законом, вы можете отозвать часть ранее предоставленных нам разрешений.</p>
        <p>Однако отзыв разрешения может повлиять на нормальное использование отдельных функций или услуг.</p>
        <h3>Ограничение или отказ от обработки</h3>
        <p>
          В случаях, предусмотренных законами и нормативными актами, вы можете потребовать от нас ограничения или
          прекращения обработки ваших персональных данных.
        </p>
        <h3>Получение копии персональных данных</h3>
        <p>
          Если это допускается применимыми законами и нормативными актами, вы можете запросить копию ваших персональных
          данных.
        </p>
        <p>
          Если вы желаете реализовать вышеуказанные права, вы можете направить нам запрос, используя контактную
          информацию, приведенную в разделе настоящей Политики «Свяжитесь с нами».
        </p>
        <p>
          <strong>
            Для обеспечения безопасности вашей учетной записи и персональных данных нам может потребоваться подтвердить
            вашу личность.
          </strong>
        </p>
      </section>
      <section>
        <h2>9. Защита персональных данных несовершеннолетних</h2>
        <p>Услуги Xiangji предназначены главным образом для совершеннолетних и бизнес-пользователей.</p>
        <p>
          <strong>
            Если вам не исполнилось 18 лет, просим прочитать настоящую Политику в сопровождении родителей или иных
            законных представителей и использовать соответствующие услуги только после получения согласия вашего
            законного представителя.
          </strong>
        </p>
        <p>
          Если мы обнаружим, что несовершеннолетний предоставил нам персональные данные без надлежащего согласия
          законного представителя, мы примем разумные меры по урегулированию такой ситуации в пределах, допускаемых
          законом.
        </p>
      </section>
      <section>
        <h2>10. Сторонние сервисы и ссылки</h2>
        <p>
          Услуги Xiangji могут содержать сторонние веб-сайты, программное обеспечение, плагины, платежные сервисы,
          ИИ-модели или иные сторонние сервисы.
        </p>
        <p>
          Например, вы можете входить в систему через стороннюю учетную запись или использовать сторонние платежные
          сервисы, ИИ-модели и иные технические услуги.
        </p>
        <p>
          <strong>
            Сторонние сервисы предоставляются соответствующими третьими сторонами самостоятельно, а их деятельность по
            обработке персональных данных регулируется собственными политиками конфиденциальности этих третьих сторон.
          </strong>
        </p>
        <p>
          Рекомендуем вам ознакомиться с политикой конфиденциальности третьей стороны до использования соответствующих
          сторонних сервисов.
        </p>
      </section>
      <section>
        <h2>11. Изменения настоящей Политики конфиденциальности</h2>
        <p>
          В связи с развитием законодательства, технологий, продуктов и бизнеса мы можем обновлять или изменять
          настоящую Политику.
        </p>
        <p>
          При внесении существенных изменений в настоящую Политику мы уведомим вас посредством объявлений на веб-сайте,
          страниц продукта, всплывающих окон, внутренних уведомлений или иными разумными способами.
        </p>
        <p>
          <strong>
            Обновленная Политика конфиденциальности вступает в силу с даты публикации или с указанной даты вступления в
            силу.
          </strong>
        </p>
        <p>Если вы не согласны с измененной Политикой, вы можете прекратить использование соответствующих услуг.</p>
        <p>
          Если вы продолжаете использовать услуги Xiangji, считается, что вы прочитали и поняли обновленную Политику
          конфиденциальности.
        </p>
      </section>
      <section>
        <h2>12. Свяжитесь с нами</h2>
        <p>
          Если у вас есть какие-либо вопросы, замечания или жалобы в отношении настоящей Политики, обработки
          персональных данных или иных вопросов конфиденциальности, вы можете связаться с нами следующими способами:
        </p>
        <ul>
          <li>
            Официальный веб-сайт:
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>Онлайн-поддержка: онлайн-поддержка внутри продуктов Xiangji</li>
          <li>Почта службы поддержки: 510807298@qq.com</li>
          <li>Наименование компании: 苏州象寄科技服务有限公司 (ООО «Сучжоу Сянцзи Текнолоджи Сервис»)</li>
          <li>
            Адрес компании: <strong>г. Шанхай, район Пудун, ул. Насянь, д. 800, здание «Кэхай»</strong>
          </li>
        </ul>
        <p>
          После получения вашего запроса, связанного с конфиденциальностью, мы обработаем его в сроки, установленные
          применимыми законами и нормативными актами.
        </p>
      </section>
    </>
  );
};

export default RuContent;
